import NavBar from "../../../components/NavBar";
import { List } from "antd-mobile";
import { useIntl } from "react-intl";

export default function Center() {
  const handleClick = () => {};

  const intl = useIntl();
  return (
    <>
      <NavBar title={intl.formatMessage({
            id: "pages.center.title",
            defaultMessage: "個人中心",
          })} />
      <List className="user_list mt-50 normal">
        <List.Item extra="garry@qq.com" onClick={handleClick}>
          {intl.formatMessage({
            id: "pages.center.email",
            defaultMessage: "Email",
          })
          }
        </List.Item>
        <List.Item extra="runner" onClick={handleClick}>
          {intl.formatMessage({
            id: "pages.center.name",
            defaultMessage: "名稱",
          })}
        </List.Item>
        <List.Item extra="secret" onClick={handleClick}>
          
          {
            intl.formatMessage({
              id: "pages.center.sex",
              defaultMessage: "性別",
            })
          }
        </List.Item>
      </List>
    </>
  );
}
